import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchAudits, fetchAuditsCSV } from '../actions/audits'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import AuditEntryList from '../components/AuditEntryList'

import AuditFilterForm from '../forms/AuditFilterForm'

import '../styles/AuditView.css'

class AuditView extends React.Component {
  constructor(props) {
    super(props)

    this.handleCSV = this.handleCSV.bind(this)
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10)
    const { role, customerId } = this.props
    if (role === 'ADMIN') {
      this.props.fetchAudits('', '', '', today, today)
    } else {
      this.props.fetchAudits(customerId, '', '', today, today)
    }
  }

  handleCSV() {
    const { fetchAuditsCSV, form } = this.props

    fetchAuditsCSV(
      form.AuditFilterForm.values.machine,
      form.AuditFilterForm.values.type,
      form.AuditFilterForm.values.StartDate,
      form.AuditFilterForm.values.EndDate
    )
  }

  renderResume() {
    const { audits, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!audits || loading) {
      return <LoadingProgress />
    }

    let counts = {
      Reboots: 0, KioscDoorOpen: 0, LoginMaintenance: 0,
      LockerOpenAll: 0, LockerOpens: 0, LockerChangePin: 0,
    }

    this.props.audits.forEach(audit => {
      const event = audit.Evento || ''
      const category = audit.Description || ''
      if (category.includes('Abriendo taquilla:')) counts.LockerOpens++
      if (category.includes('Cambiando pin taquilla:')) counts.LockerChangePin++
      if (category.includes('Abriendo todas las taquillas')) counts.LockerOpenAll++
      if (event.includes('LOGIN MANTENIMIENTO') && category.includes('LOGIN CORRECTO')) counts.LoginMaintenance++
      if (category.includes('Reinicio manual de máquina') || event.includes('REBOOT')) counts.Reboots++
      if (event.includes('ABRIR PUERTA') && category.includes('Puerta Abierta')) counts.KioscDoorOpen++
    })

    const stats = [
      { label: 'Reinicios', value: counts.Reboots, icon: 'fa-redo', color: '#e53935' },
      { label: 'Apert. puerta kiosco', value: counts.KioscDoorOpen, icon: 'fa-door-open', color: '#fb8c00' },
      { label: 'Logins mantenimiento', value: counts.LoginMaintenance, icon: 'fa-key', color: '#1e88e5' },
      { label: 'Abrir todas', value: counts.LockerOpenAll, icon: 'fa-lock-open', color: '#8e24aa' },
      { label: 'Abrir taquilla', value: counts.LockerOpens, icon: 'fa-box-open', color: '#43a047' },
      { label: 'Cambio de pin', value: counts.LockerChangePin, icon: 'fa-hashtag', color: '#00acc1' },
    ]

    return (
      <div className="audit-summary-grid">
        {stats.map(s => (
          <div key={s.label} className="audit-summary-stat">
            <div className="audit-stat-icon" style={{ color: s.color }}>
              <i className={`fas ${s.icon}`}></i>
            </div>
            <div className="audit-stat-value">{s.value}</div>
            <div className="audit-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    )
  }

  renderAudits() {
    const { audits, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!audits || loading) {
      return <LoadingProgress />;
    }

    return (<AuditEntryList audits={audits} />)
  }

  render() {
    return (
      <div className="audit-view">
        <div className="audit-header">
          <div className="audit-header-content">
            <div className="audit-header-text">
              <h1>
                <i className="fas fa-clipboard-list mr-3"></i>
                <span className="text-vw-dark mr-1">Audit</span>
                <span className="text-vw-light">Log</span>
              </h1>
            </div>
            <div className="audit-header-actions">
              <button className="audit-header-btn success" onClick={this.handleCSV}>
                <i className="fas fa-file-excel"></i>
                <span>Descargar CSV</span>
              </button>
            </div>
          </div>
        </div>

        <div className="audit-filter-card">
          <div className="audit-filter-header">
            <h3><i className="fas fa-filter"></i> Filtros</h3>
          </div>
          <div className="audit-filter-body">
            <AuditFilterForm />
          </div>
        </div>

        <div className="audit-section-card">
          <div className="audit-section-header">
            <i className="fas fa-chart-bar mr-2"></i>Resumen del período
          </div>
          <div className="audit-section-body">
            {this.renderResume()}
          </div>
        </div>

        <div className="audit-section-card">
          <div className="audit-section-header">
            <i className="fas fa-list mr-2"></i>Registros
          </div>
          <div className="audit-section-body p-0">
            {this.renderAudits()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  audits: state.audits.audits,
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
  role: state.auth.role,
  customerId: state.auth.id,
})

const mapDispatchToProps = dispatch => ({
  fetchAudits: bindActionCreators(fetchAudits, dispatch),
  fetchAuditsCSV: bindActionCreators(fetchAuditsCSV, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(AuditView)


